/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CreateTspotTestDtoInterpretation =
  (typeof CreateTspotTestDtoInterpretation)[keyof typeof CreateTspotTestDtoInterpretation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTspotTestDtoInterpretation = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  INDETERMINATE: 'INDETERMINATE',
  NOT_EXECUTED: 'NOT_EXECUTED',
  PENDING: 'PENDING',
  NONE: 'NONE',
} as const;
